import { Button, ButtonGroup, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function ExportButton() {
  return (
    <ButtonGroup isAttached>
      <Button
        color={"#6C6B6E"}
        borderColor={"#D4D4D4"}
        backgroundColor={"#FFFFFF"}
        border="1px solid #D4D4D4"
        variant="outline"
        size="sm"
      >
        Export
      </Button>
      <Menu>
        <MenuButton
          as={Button}
          color={"#6C6B6E"}
          borderColor={"#D4D4D4"}
          size="sm"
          variant="outline"
        >
          <FontAwesomeIcon icon={["fas", "chevron-down"]} size="xs" />
        </MenuButton>
        <MenuList>
          <MenuItem>Sample</MenuItem>
        </MenuList>
      </Menu>
    </ButtonGroup>
  );
}
